// src/components/AgendamentoEnvioModal.js
import React, { useState, useEffect } from 'react';

function AgendamentoEnvioModal({ isOpen, onClose, oportunidade, onConfirmar }) {
  const [dados, setDados] = useState({
    nome_cliente: '',
    whatsapp: '',
    valor: 0,
    tipo_servico: 'com_cobranca', // com_cobranca, sem_cobranca, ja_pago
    data_envio: '',
    hora_envio: '07:00',
    mensagem_personalizada: '',
    enviado_por: 'salatiel', // salatiel ou empresa
    tipo_pdf: 'gestao_click' // gestao_click ou proposta_ia
  });
  
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (isOpen && oportunidade) {
      // Preenche dados iniciais
      setDados({
        nome_cliente: oportunidade.cliente_nome || '',
        whatsapp: oportunidade.cliente_telefone || '',
        valor: oportunidade.valor_real || 0,
        tipo_servico: oportunidade.valor_real > 0 ? 'com_cobranca' : 'sem_cobranca',
        data_envio: '',
        hora_envio: '07:00',
        mensagem_personalizada: '',
        enviado_por: 'salatiel',
        tipo_pdf: oportunidade.proposta_ia_gerada ? 'proposta_ia' : 'gestao_click' // Auto-seleciona se tem IA
      });
    }
  }, [isOpen, oportunidade]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validações
    if (!dados.nome_cliente) {
      alert('Nome do cliente é obrigatório!');
      return;
    }
    
    if (!dados.whatsapp || dados.whatsapp.trim().length < 10) {
      alert('Digite um número de WhatsApp válido!');
      return;
    }
    
    if (!dados.data_envio) {
      alert('Selecione a data de envio!');
      return;
    }
    
    if (dados.tipo_servico === 'com_cobranca' && dados.valor <= 0) {
      alert('Informe o valor do serviço!');
      return;
    }

    // Validar se escolheu proposta IA mas não foi gerada
    if (dados.tipo_pdf === 'proposta_ia' && !oportunidade.proposta_ia_gerada) {
      alert('❌ Proposta IA não foi gerada ainda!\n\nClique em "Gerar Proposta IA" no card antes de agendar.');
      return;
    }
    
    setEnviando(true);
    
    try {
      const dataHoraEnvio = `${dados.data_envio}T${dados.hora_envio}:00`;
      
      await onConfirmar({
        data_envio: dataHoraEnvio,
        whatsapp: dados.whatsapp.trim(),
        mensagem_personalizada: dados.mensagem_personalizada.trim() || null,
        nome_cliente: dados.nome_cliente,
        tipo_servico: dados.tipo_servico,
        valor: dados.tipo_servico === 'com_cobranca' ? dados.valor : 0,
        tipo_pdf: dados.tipo_pdf // NOVO: Tipo de PDF a enviar
      });
      
      onClose();
    } catch (error) {
      console.error('Erro ao agendar envio:', error);
      alert('Erro ao agendar envio!');
    } finally {
      setEnviando(false);
    }
  };

  if (!isOpen) return null;

  const getNumeroOS = () => {
    const match = oportunidade?.titulo?.match(/OS (\d+)/);
    return match ? match[1] : '';
  };

  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⏰ Agendar Envio de Orçamento - OS #{getNumeroOS()}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            
            {/* ESCOLHER TIPO DE PDF */}
            <div className="info-section">
              <h3>📄 Tipo de Proposta</h3>
              <div className="radio-group">
                <label className="radio-option">
                  <input
                    type="radio"
                    name="tipo_pdf"
                    value="gestao_click"
                    checked={dados.tipo_pdf === 'gestao_click'}
                    onChange={(e) => setDados({...dados, tipo_pdf: e.target.value})}
                  />
                  <span>📋 PDF Padrão (Gestão Click)</span>
                </label>
                
                <label 
                  className="radio-option"
                  style={{
                    opacity: oportunidade.proposta_ia_gerada ? 1 : 0.5,
                    cursor: oportunidade.proposta_ia_gerada ? 'pointer' : 'not-allowed'
                  }}
                >
                  <input
                    type="radio"
                    name="tipo_pdf"
                    value="proposta_ia"
                    checked={dados.tipo_pdf === 'proposta_ia'}
                    onChange={(e) => setDados({...dados, tipo_pdf: e.target.value})}
                    disabled={!oportunidade.proposta_ia_gerada}
                  />
                  <span>
                    ✨ Proposta IA (Profissional)
                    {oportunidade.proposta_ia_gerada && <span style={{color: '#10b981', marginLeft: '8px'}}>✅ Disponível</span>}
                    {!oportunidade.proposta_ia_gerada && <span style={{color: '#ef4444', marginLeft: '8px'}}>⚠️ Não gerada</span>}
                  </span>
                </label>
              </div>
              
              {!oportunidade.proposta_ia_gerada && (
                <div style={{
                  background: '#fef3c7',
                  padding: '12px',
                  borderRadius: '6px',
                  marginTop: '10px',
                  border: '1px solid #f59e0b'
                }}>
                  <p style={{margin: 0, fontSize: '13px', color: '#92400e'}}>
                    💡 <strong>Dica:</strong> Clique em "✨ Gerar Proposta IA" no card para criar uma proposta profissional com descrições e diferenciais destacados!
                  </p>
                </div>
              )}

              {dados.tipo_pdf === 'proposta_ia' && oportunidade.proposta_ia_gerada && (
                <div style={{
                  background: '#d1fae5',
                  padding: '12px',
                  borderRadius: '6px',
                  marginTop: '10px',
                  border: '1px solid #10b981'
                }}>
                  <p style={{margin: 0, fontSize: '13px', color: '#065f46'}}>
                    ✅ A proposta IA será enviada! Ela inclui descrições profissionais, diferenciais da GVS e layout otimizado.
                  </p>
                </div>
              )}
            </div>

            {/* TIPO DE SERVIÇO */}
            <div className="info-section">
              <h3>Tipo de Serviço</h3>
              <div className="radio-group">
                <label className="radio-option">
                  <input
                    type="radio"
                    name="tipo_servico"
                    value="com_cobranca"
                    checked={dados.tipo_servico === 'com_cobranca'}
                    onChange={(e) => setDados({...dados, tipo_servico: e.target.value})}
                  />
                  <span>💰 Com Cobrança</span>
                </label>
                
                <label className="radio-option">
                  <input
                    type="radio"
                    name="tipo_servico"
                    value="sem_cobranca"
                    checked={dados.tipo_servico === 'sem_cobranca'}
                    onChange={(e) => setDados({...dados, tipo_servico: e.target.value})}
                  />
                  <span>🎁 Sem Cobrança (Garantia/Cortesia)</span>
                </label>
                
                <label className="radio-option">
                  <input
                    type="radio"
                    name="tipo_servico"
                    value="ja_pago"
                    checked={dados.tipo_servico === 'ja_pago'}
                    onChange={(e) => setDados({...dados, tipo_servico: e.target.value})}
                  />
                  <span>✅ Já Pago</span>
                </label>
              </div>
            </div>

            {/* DADOS DO CLIENTE */}
            <div className="info-section">
              <h3>Dados do Cliente</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Nome do Cliente *</label>
                  <input
                    type="text"
                    value={dados.nome_cliente}
                    onChange={(e) => setDados({...dados, nome_cliente: e.target.value})}
                    placeholder="Nome completo"
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label>Telefone (WhatsApp) *</label>
                  <input
                    type="tel"
                    value={dados.whatsapp}
                    onChange={(e) => setDados({...dados, whatsapp: e.target.value})}
                    placeholder="16999999999"
                    required
                  />
                  <small>Apenas números (DDD + número)</small>
                </div>
              </div>
            </div>

            {/* ENVIAR DE QUAL NÚMERO */}
            <div className="info-section">
              <h3>📱 Enviar de Qual Número?</h3>
              <div className="radio-group">
                <label className="radio-option">
                  <input
                    type="radio"
                    name="enviado_por"
                    value="salatiel"
                    checked={dados.enviado_por === 'salatiel'}
                    onChange={(e) => setDados({...dados, enviado_por: e.target.value})}
                  />
                  <span>👤 Salatiel - GVS (Pessoal)</span>
                </label>
              </div>
              <small style={{display: 'block', marginTop: '10px', color: '#666'}}>
                O orçamento será enviado do número selecionado
              </small>
            </div>

            {/* VALOR - Só mostra se for COM COBRANÇA */}
            {dados.tipo_servico === 'com_cobranca' && (
              <div className="info-section">
                <h3>Valor do Serviço</h3>
                <div className="form-group">
                  <label>Valor Total *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={dados.valor}
                    onChange={(e) => setDados({...dados, valor: parseFloat(e.target.value)})}
                    placeholder="0.00"
                    required
                  />
                  <small>As formas de pagamento serão calculadas automaticamente</small>
                </div>
              </div>
            )}

            {/* DATA E HORA DE ENVIO */}
            <div className="info-section">
              <h3>⏰ Agendamento de Envio</h3>
              <div style={{
                background: '#e3f2fd',
                padding: '15px',
                borderRadius: '8px',
                marginBottom: '20px',
                border: '1px solid #2196f3'
              }}>
                <p style={{margin: 0, fontSize: '14px', color: '#1976d2'}}>
                  📱 <strong>O orçamento será enviado automaticamente via WhatsApp no horário agendado!</strong>
                </p>
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <label>📅 Data de Envio: *</label>
                  <input
                    type="date"
                    value={dados.data_envio}
                    onChange={(e) => setDados({...dados, data_envio: e.target.value})}
                    required
                    style={{
                      width: '100%',
                      padding: '10px',
                      borderRadius: '4px',
                      border: '1px solid #ddd',
                      fontSize: '14px'
                    }}
                  />
                  <small>Escolha a data em que o orçamento deve ser enviado</small>
                </div>

                <div className="form-group">
                  <label>🕐 Horário de Envio: *</label>
                  <input
                    type="time"
                    value={dados.hora_envio}
                    onChange={(e) => setDados({...dados, hora_envio: e.target.value})}
                    required
                    style={{
                      width: '100%',
                      fontSize: '14px',
                      padding: '8px',
                      border: '1px solid #ddd',
                      borderRadius: '4px'
                    }}
                  />
                  <small>Escolha qualquer horário</small>
                </div>
              </div>
            </div>

            {/* MENSAGEM PERSONALIZADA (OPCIONAL) */}
            <div className="info-section">
              <h3>💬 Mensagem Personalizada (Opcional)</h3>
              <div className="form-group">
                <textarea
                  value={dados.mensagem_personalizada}
                  onChange={(e) => setDados({...dados, mensagem_personalizada: e.target.value})}
                  placeholder="Ex: Conforme conversamos, segue o orçamento solicitado..."
                  rows="3"
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
                <small>Esta mensagem será adicionada no início do orçamento</small>
              </div>
            </div>

            {/* PRÉVIA DA MENSAGEM */}
            <div className="info-section">
              <h3>📱 Prévia da Mensagem</h3>
              <div style={{
                background: '#f5f5f5',
                padding: '15px',
                borderRadius: '8px',
                whiteSpace: 'pre-line',
                fontSize: '14px',
                border: '1px solid #ddd'
              }}>
                {gerarPrevia(dados, oportunidade)}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              type="button" 
              onClick={onClose} 
              className="btn-secondary"
              disabled={enviando}
            >
              Cancelar
            </button>
            <button 
              type="submit" 
              className="btn-primary"
              disabled={enviando}
              style={{
                backgroundColor: '#2196f3',
                color: 'white'
              }}
            >
              {enviando ? '⏳ Agendando...' : '⏰ Agendar Envio'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Função auxiliar para gerar prévia
function gerarPrevia(dados, oportunidade) {
  const saudacao = getSaudacao();
  const valorTotal = parseFloat(dados.valor) || 0;
  const valorComDescontoPix = valorTotal * 0.95;
  const numeroOS = oportunidade?.titulo?.match(/OS (\d+)/)?.[0] || 'OS #';
  const hashOS = oportunidade?.hash_os;

  let mensagem = '';

  // Mensagem personalizada (se houver)
  if (dados.mensagem_personalizada) {
    mensagem += `${dados.mensagem_personalizada}\n\n`;
  }

  // Cabeçalho
  mensagem += `📋 *ORÇAMENTO - Grupo GVS*\n\n`;
  mensagem += `${saudacao} ${dados.nome_cliente || '[Nome do Cliente]'}! 👋\n\n`;
  
  // Menciona tipo de proposta
  if (dados.tipo_pdf === 'proposta_ia') {
    mensagem += `Segue sua proposta comercial personalizada:\n\n`;
  } else {
    mensagem += `Segue o orçamento solicitado:\n\n`;
  }

  // Link para visualizar/imprimir (se tiver hash)
  if (hashOS) {
    mensagem += `🔗 *Link para visualizar/imprimir:*\n`;
    mensagem += `https://gestaoclick.com/os/${hashOS}\n\n`;
  }

  // Dados do orçamento
  mensagem += `📄 Orçamento: ${numeroOS}\n`;

  if (dados.tipo_servico === 'com_cobranca') {
    const valorFormatado = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valorTotal);

    mensagem += `💰 Valor: ${valorFormatado}\n`;
    mensagem += `📅 Validade: 15 dias\n\n`;

    // Formas de pagamento
    mensagem += `*As formas de pagamento disponíveis para este atendimento são:*\n\n`;

    // PIX
    const valorFormatadoPix = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valorComDescontoPix);
    
    mensagem += `📱 *PIX com 5% de desconto:* ${valorFormatadoPix}\n`;
    mensagem += `   CNPJ: 27.820.945/0001-06\n\n`;

    // BOLETO
    if (valorTotal >= 100) {
      const opcoesBoleto = calcularParcelamentoBoleto(valorTotal);
      mensagem += `📄 *Boleto Bancário:*\n`;
      
      if (opcoesBoleto.length === 1) {
        mensagem += `   À vista: ${opcoesBoleto[0].descricao.split(': ')[1]}\n\n`;
      } else {
        opcoesBoleto.forEach(opcao => {
          mensagem += `   ${opcao.descricao}\n`;
        });
        mensagem += `\n`;
      }
    }

    // CARTÃO
    const valorParcela = valorTotal / 4;
    const valorParcelaFormatado = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valorParcela);
    
    mensagem += `💳 *Cartão de Crédito:*\n`;
    mensagem += `   Em até 4x de ${valorParcelaFormatado} sem juros\n\n`;
  } else if (dados.tipo_servico === 'sem_cobranca') {
    mensagem += `🎁 *Serviço sem cobrança (Garantia/Cortesia)*\n`;
    mensagem += `📅 Validade: 15 dias\n\n`;
  } else {
    // já_pago
    mensagem += `✅ *Serviço já pago*\n`;
    mensagem += `📅 Validade: 15 dias\n\n`;
  }

  mensagem += `Qualquer dúvida, estamos à disposição!\n\n`;
  mensagem += `Grupo GVS - Soluções em Tecnologia 🙏`;

  return mensagem;
}

// Função para calcular parcelamento boleto
function calcularParcelamentoBoleto(valorTotal) {
  const opcoes = [];
  const formatarValor = (valor) => new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor);
  
  if (valorTotal < 100) {
    return opcoes;
  }
  
  if (valorTotal < 200) {
    opcoes.push({
      descricao: `À vista: ${formatarValor(valorTotal)}`
    });
  }
  else if (valorTotal < 500) {
    const valor2x = valorTotal / 2;
    if (valor2x >= 100) {
      opcoes.push({
        descricao: `2x de ${formatarValor(valor2x)} (vencimento em 7 e 28 dias)`
      });
    } else {
      opcoes.push({
        descricao: `À vista: ${formatarValor(valorTotal)}`
      });
    }
  }
  else {
    const valor4x = valorTotal / 4;
    if (valor4x >= 100) {
      opcoes.push({
        descricao: `4x de ${formatarValor(valor4x)} (vencimento a cada 22 dias)`
      });
    }
    
    const valor3x = valorTotal / 3;
    if (valor3x >= 100) {
      opcoes.push({
        descricao: `3x de ${formatarValor(valor3x)} (vencimento a cada 30 dias)`
      });
    }
    
    const valor2x = valorTotal / 2;
    opcoes.push({
      descricao: `2x de ${formatarValor(valor2x)} (vencimento em 7 e 28 dias)`
    });
  }
  
  return opcoes;
}

// Função para saudação por horário
function getSaudacao() {
  const hora = new Date().getHours();
  
  if (hora >= 6 && hora < 12) {
    return '🌅 Bom dia';
  } else if (hora >= 12 && hora < 18) {
    return '☀️ Boa tarde';
  } else {
    return '🌙 Boa noite';
  }
}

export default AgendamentoEnvioModal;